import { useState, useEffect } from 'react';
import getEmbeddedReportUrl from '../../repository/embedded-reports/getEmbeddedReportUrl';

const useViewEmbeddedReport = ({ reportIdentifier, queryParams }) => {
    const [report, setReport] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchReport = async () => {
        setLoading(true);
        try {
            const { resource } = await getEmbeddedReportUrl(reportIdentifier);

            if (queryParams) {
                const url = new URL(resource.embedUrl);

                Object.entries(queryParams).forEach(([key, value]) => {
                    url.searchParams.append(key, value);
                });

                resource.embedUrl = url.toString();
            }

            setReport(resource);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (reportIdentifier) fetchReport();
    }, [reportIdentifier, queryParams]);

    return { report, loading, error };
};

export default useViewEmbeddedReport;
